export enum ClientDocumentRelation {
  CannotRead = 'cannot-read',
  CanRead = 'can-read',
  MustRead = 'must-read',
  MustSign = 'must-sign',
}
